import get from 'lodash/get';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import Loading from 'components/Loading/Loading';

import IssueDetails from '../../IssueDetails';
import { fetchAppointment } from '../../../../actions/Admin/appointmentActions';
import { respondToDispute } from '../../../../actions/Admin/disputeActions';

import './style.css';

class ShowIssue extends Component {
  constructor() {
    super();
    this.state = {
      resolutionDescription: ''
    };
  }

  componentWillMount() {
    const { issue } = this.props.location.state;
    if (!issue.appointment) {
      this.props.fetchAppointment(issue.appointmentId);
    }
  }

  validateResolution = () => {
    if (this.state.resolutionDescription.length < 10) {
      alert('You must provide a resolution description');
      return false;
    }
    return true;
  }

  handleResolutionChange = (e) => {
    this.setState({ resolutionDescription: e.target.value });
  }

  approve = (issueId) => {
    if (this.validateResolution()) {
      this.props.respondToDispute(issueId, this.state.resolutionDescription, 1);
    }
  }

  deny = (issueId) => {
    if (this.validateResolution()) {
      this.props.respondToDispute(issueId, this.state.resolutionDescription, 0);
    }
  }

  isSubmitDisabled = () => {
    return this.props.dispute.status === 'SUBMITTING';
  }

  renderIssueInfoRow(lhs, rhs) {
    return (
      <div className="row" style={{ marginLeft: 0 }}>
        <div style={{ width: 125 }}>
          <strong>{lhs}</strong>
        </div>
        <div>{rhs}</div>
      </div>
    );
  }

  render() {
    const issue = get(this.props.dispute, 'dispute.issue') || this.props.location.state.issue;
    const appointment = issue.appointment || get(this.props.appointment, 'appointment.data.data');

    return (
      <div className="ShowIssue">
        <div className="col-auto">
          <div className="row">
            <Link to="/admin/search-issues">
              <i className="fa fa-chevron-left mr-1" />
              <span className="breadcrumb-text"> Back </span>
            </Link>
          </div>
          <div className="row mt-2 mb-2">
            <div className="card">
              {!appointment && this.props.appointment.status === 'FAIL' && <div>Problem</div>}
              {!appointment &&
                (this.props.appointment.status === 'LOADING' ||
                  this.props.appointment.status === null) && <Loading />}

              {appointment && (
                <div>
                  <IssueDetails
                    appointment={appointment}
                    issue={issue}
                    resolutionDescription={this.state.resolutionDescription}
                    handleResolutionChange={this.handleResolutionChange}
                    approve={this.approve}
                    deny={this.deny}
                    isSubmitDisabled={this.isSubmitDisabled}
                  />
                  {this.props.dispute.status === 'SUBMIT_FAILED' && (
                    <div className="mt-2">Problem submitting</div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    appointment: state.appointment,
    dispute: state.dispute
  };
}

export default connect(
  mapStateToProps,
  { fetchAppointment, respondToDispute }
)(ShowIssue);



// WEBPACK FOOTER //
// ./src/pages/admin/routes/ShowIssue/index.js